import { useEffect, useState } from "react"
import GoodCard from "./card"
import { getGoodsList } from "../../../utils/func"

export default function GoodsGridList({
    is_need_fetch, // is_need_fetch 为true的话，要重新加载
    brand_ids, 
    category_ids, 
    goods_display_num, 
    goods_list_title,
    list
}) {

    console.log('14 grid list is', list)
    const [nlist,setNlist] = useState([])

    useEffect(() => {
        handleList()
    }, [])

    function handleList() {
        if(is_need_fetch) {
            getGoodsList(1, goods_display_num).then(result => {
                setNlist(result)
            }).catch(err => {

            })
        } else {

            setNlist(list)
        }
    }

    const flist = is_need_fetch ? nlist : list 

    return (
        <div className="row d-flex justify-content-center">
            {
                flist && flist?.length > 0 && flist.map((item,index) => {
                    return (
                        <GoodCard 
                            item={item}
                            className={"col-lg-4 col-md-6 col-xs-100pc m-b30"}
                            key={`good-${index}`}
                        />
                    )
                })
            }
        </div>
    )
}